import { render, staticRenderFns } from "./DamageList.vue?vue&type=template&id=3b5b2509&"
import script from "./DamageList.vue?vue&type=script&lang=js&"
export * from "./DamageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports